import React, { useState, useEffect } from "react";
import { auth, signInWithPhoneNumber } from "./firebaseConfig";
import axios from "axios";
import { Input } from "reactstrap";
import Turnstile from "react-turnstile";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  PhoneAuthProvider,
  signInWithCredential,
  RecaptchaVerifier,
  signInWithCustomToken,
} from "firebase/auth";

const PhoneAuth1 = ({ setPhoneNumberOut, user }) => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("+94");
  const [otp, setOtp] = useState("");
  const [verificationId, setVerificationId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isRecaptchaSolved, setIsRecaptchaSolved] = useState(false);
  const [verificationStage, setVerificationStage] = useState("send-otp");
  const [otpSentTime, setOtpSentTime] = useState(null);
  const [countdown, setCountdown] = useState(30);
  const [showOtpSender, setShowOtpSender] = useState(true);
  const [showOtpInput, setShowOtpInput] = useState(false);

  const [token, setToken] = useState(null);

  const handleTurnstileResponse = (token) => {
    setToken(token);
  };
  const setUpRecaptcha = () => {
    const recaptchaContainer = document.getElementById("recaptcha-container");

    if (recaptchaContainer) {
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new RecaptchaVerifier(
          "recaptcha-container", // reCAPTCHA container id

          {
            size: "normal", // visible reCAPTCHA
            callback: (response) => {
              console.log("Recaptcha solved:", response);
              //window.recaptchaVerifier.recaptcha.reset();
            },
            "expired-callback": () => {
              console.log("Recaptcha expired");
              // window.recaptchaVerifier.recaptcha.reset();
            },
          },
          auth // Firebase auth instance
        );
      }
    } else {
      console.log("Recaptcha container is missing in the DOM");
    }
  };
  // Send OTP to the phone number
  const sendOtp = async () => {
    try {
      setShowOtpSender(false);
      setShowOtpInput(true);
      setCountdown(120);
      //alert("hello world");

      const response = await axios.post(
        "https://api.starmarketapi.online/login_firebase/send-otp",
        {
          phoneNumber,
        }
      );
      //alert(phoneNumber);

      setPhoneNumberOut(phoneNumber);
      console.log(response.data.message);
      setVerificationStage("verify-otp");
      setOtpSentTime(Date.now());

      let timer;
      if (countdown > 0) {
        timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);
      } else {
        clearInterval(timer); // Clear the timer once countdown reaches 0
        setCountdown(120);
      }
      return () => clearInterval(timer);
    } catch (error) {
      console.error(
        "Error sending OTP:",
        error.response?.data?.message || error.message
      );
      toast.error(
        error.response?.data?.message ||
          "Failed to send OTP. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
      setShowOtpSender(true);
      setShowOtpInput(false);
    }
  };

  const verifyOtp = async () => {
    if (!token) {
      toast.error("Please complete the CAPTCHA.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // Send token to the backend for verification
    fetch("https://api.starmarketapi.online/login_firebase/verify-turnstile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          toast.success("CAPTCHA verified successfully!", {
            position: "top-right",
            autoClose: 2000,
          });
        } else {
          toast.error("Captcha verification failed.", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      });
    try {
      const otpExpireTime = 120000; // 30 seconds in milliseconds
      const currentTime = Date.now();

      if (otpSentTime && currentTime - otpSentTime > otpExpireTime) {
        toast.error("OTP has expired. Please request a new one.", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }

      const response = await axios.post(
        "https://api.starmarketapi.online/login_firebase/verify-otp-register",
        {
          phoneNumber,
          otp,
          role: user.role,
        }
      );
      const customToken = response.data.token;

      // Sign in using Firebase custom token
      const userCredential = await axios.post(
        "https://api.starmarketapi.online/login_firebase/create-user-tp",
        {
          firstName: user.firstName,
          lastName: user.lastName,
          companyName: user.companyName,
          telephone: phoneNumber,
          role: user.role,
        }
      );
      console.log("User signed up:", userCredential);
      toast.success("User Created successfully!", {
        position: "top-right",
        autoClose: 2000,
      });
      setTimeout(() => {
        navigate("/signin");
      }, 2000);
    } catch (error) {
      console.error(
        "Error verifying OTP:",
        error.response?.data?.message || error.message
      );
      toast.error(
        error.response?.data?.message ||
          "Error Creating User. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  return (
    <div>
      <div id="recaptcha-container"></div>
      {/* Phone Input */}
      {showOtpSender && (
        <form>
          <div className="otp-sender">
            <div className="mb-3">
              <Input
                type="text"
                className="form-control"
                value={phoneNumber}
                onChange={(e) => {
                  const input = e.target.value;
                  // Always keep +94 prefix
                  if (!input.startsWith("+94")) {
                    setPhoneNumber("+94");
                  } else {
                    // Only allow numbers after +94, max 10 digits
                    const numbers = input.slice(3).replace(/\D/g, "");
                    if (numbers.length <= 9) {
                      setPhoneNumber("+94" + numbers);
                    }
                  }
                }}
                placeholder="+94"
                style={{ background: "#f8f9fc" }}
                required
              />
            </div>

            <div className="text-center mb-2">
              <button onClick={sendOtp} className="btn-blue btn-hover w-100">
                Send code via SMS
              </button>
            </div>
          </div>
        </form>
      )}
      {/* OTP Input */}
      {showOtpInput && (
        <div className="otp-input">
          <div className="mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter OTP"
              value={otp}
              style={{ background: "#f8f9fc" }}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
          <Turnstile
            sitekey="0x4AAAAAABOACzBCG9VMleRw"
            onVerify={handleTurnstileResponse}
          />
          <div className="text-center mb-2">
            <button onClick={verifyOtp} className="btn-blue btn-hover w-100">
              Verify OTP
            </button>
          </div>
          {/* Show Countdown Timer */}
          {countdown > 0 && <p>Time remaining: {countdown}s</p>}
          {countdown <= 0 && (
            <p className="text-black">
              OTP expired.{" "}
              <a
                onClick={sendOtp}
                className="text-blue btn-hover w-100"
                style={{ cursor: "pointer" }}
              >
                Resend
              </a>
            </p>
          )}
        </div>
      )}
      {/* Recaptcha */}
    </div>
  );
};

export default PhoneAuth1;
